/**
 * @mergeTarget
 * @module Src/Parameters/String/Options
 */
/**
 * Enumerator of options for {@link Src/Parameters/String.LisioStringParameterNames.TEXT_ALIGN} parameter
 * @source
 */
var TextAlignOptions;
(function (TextAlignOptions) {
    TextAlignOptions["CENTER"] = "center";
    TextAlignOptions["RIGHT"] = "right";
    TextAlignOptions["LEFT"] = "left";
    TextAlignOptions["JUSTIFY"] = "justify";
})(TextAlignOptions || (TextAlignOptions = {}));
export { TextAlignOptions };
